import {
  FEEDBACK_ITEM_STATUSES
} from 'screens/Studio/Studio/components/StudioFeedback/constants';
import {
  updateFeedbackItem,
  setFeedbackOpen
} from 'screens/Studio/Studio/components/StudioFeedback/state';

import { RedesignRequest } from '../models';
import {
  REDESIGN_REQUEST_STATUSES
} from '../constants';
import {
  getRedesignRequest
} from './selectors';

export const SET_SELECTED_NAV_TAB = 'LS_STUDIO_REDESIGN_REQUESTS/SET_SELECTED_NAV_TAB';

export const CREATE_REDESIGN_REQUEST = 'LS_STUDIO_REDESIGN_REQUESTS/CREATE_REDESIGN_REQUEST';
export const DELETE_REDESIGN_REQUEST = 'LS_STUDIO_REDESIGN_REQUESTS/DELETE_REDESIGN_REQUEST';
export const UPDATE_REDESIGN_REQUEST = 'LS_STUDIO_REDESIGN_REQUESTS/UPDATE_REDESIGN_REQUEST';
export const SELECT_REDESIGN_REQUEST = 'LS_STUDIO_REDESIGN_REQUESTS/SELECT_REDESIGN_REQUEST';

export const setSelectedNavTab = (index) => ({
  type: SET_SELECTED_NAV_TAB,
  payload: {
    selectedNavTab: index
  }
});

export const createRedesignRequest = ({ redesignRequest }) => ({
  type: CREATE_REDESIGN_REQUEST,
  payload: {
    redesignRequest
  }
});

export const updateRedesignRequest = ({ id, updateData }) => ({
  type: UPDATE_REDESIGN_REQUEST,
  payload: {
    id,
    updateData
  }
});

export const deleteRedesignRequest = ({ id }) => ({
  type: DELETE_REDESIGN_REQUEST,
  payload: {
    id
  }
});

export const selectRedesignRequest = ({ id }) => ({
  type: SELECT_REDESIGN_REQUEST,
  payload: {
    id
  }
});

export const confirmFeedbackChanges = ({ feedbackItem, spaceId, designId }) => (dispatch, getState) => {
  if (!feedbackItem || !spaceId || !designId) {
    return null;
  }
  const redesignRequestId = RedesignRequest.buildRedesignRequestKey({
    spaceId,
    designId
  });
  const existingRedesignRequest = getRedesignRequest({ id: redesignRequestId, state: getState() });
  if (existingRedesignRequest) {
    const existingFeedbackItems = existingRedesignRequest.feedbackItems();
    dispatch(updateRedesignRequest({
      id: redesignRequestId,
      updateData: {
        spaceId,
        designId,
        feedbackItems:
        [
          ...existingFeedbackItems.filter((e) => e !== feedbackItem.id()),
          feedbackItem.id()
        ],
        status: REDESIGN_REQUEST_STATUSES.PENDING
      }
    }));
    dispatch(selectRedesignRequest({ id: existingRedesignRequest.id() }));
  } else {
    const redesignRequest = new RedesignRequest({
      spaceId,
      designId,
      feedbackItems: [ feedbackItem.id() ],
      status: REDESIGN_REQUEST_STATUSES.PENDING
    });
    dispatch(createRedesignRequest({ redesignRequest }));
    dispatch(selectRedesignRequest({ id: redesignRequest.id() }));
  }
  dispatch(updateFeedbackItem({
    id: feedbackItem.id(),
    updateData: {
      status: FEEDBACK_ITEM_STATUSES.CONFIRMED
    }
  }));
  dispatch(setFeedbackOpen(false));
};
